import React,{ useState, useEffect } from "react";
// import { MSALObj } from "../auth/authInstance";
import { Redirect } from "react-router-dom";
import { RootStoreModel } from "../redux/reducers";
import { useSelector } from "react-redux";
import { LoadingPage } from "./loading";
import Store from "../redux/store";
import {
  getLoginCallback
} from "../auth/authInstance";
import {
  UserLoginAction,
  UpdateLogStatus,
  FetchingOrgsTree,
  FetchingAccount,
  FetchedLoding,
  UpdateRegisShow
} from "../redux/actions";
import { notification } from "antd";
function NavPage() {
  // console.log(props);
  // if () {
  return <Redirect to="/home/index" />;
  // } else {
  // return <Redirect to="/home/bind" />;
  // }
}

function RedirectPage() {
  const [isLogin,setIsLogin]  =useState<boolean>(false);
  const LOADING = false;
  useEffect(()=>{
    getLoginCallback().then(re=>{
      if(re){
        Store.dispatch(UpdateLogStatus(true));
        Store.dispatch(UserLoginAction(re));
        Store.dispatch(FetchingAccount());
        setIsLogin(true)
      }else{
        setIsLogin(false)
        Store.dispatch(FetchedLoding(false));
      }
    })
  }, [])
  return (
    <div >
      {!isLogin? (
        <LoadingPage></LoadingPage>
      ) : (
        <NavPage></NavPage>
      )}
    </div>
  );
}

export default RedirectPage;
